const normalizeTitle = (s) => s.replace(/([A-Z])/g, ' $1').trim();
const normalizeCommand = (s) => s.replace(/([A-Z])/g, '_$1').replace(/\s+/g, '_').replace(/^_/, '').toUpperCase();

/**
 * Format currency value for display
 * @param {number|string|null|undefined} value - The value to format
 * @param {string} currency - Currency code (default: 'USD')
 * @param {number} decimals - Number of decimal places (default: 2)
 * @returns {string} Formatted currency string or fallback
 */
const formatCurrency = (value, currency = 'USD', decimals = 2) => {
  if (value === null || value === undefined || value === '' || isNaN(Number(value))) {
    return '—';
  }

  const numValue = Number(value);
  
  // Simple formatter for USD (most common case)
  if (currency === 'USD' || currency === '$') {
    return `$${numValue.toFixed(decimals)}`;
  }
  
  // Generic fallback with currency code
  return `${numValue.toFixed(decimals)} ${currency}`;
};

export { normalizeTitle, normalizeCommand, formatCurrency };
